import React from 'react';
import { HONDA_SITE_NAME } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
import FreeFormTextUI from './FreeFormTextUI';
import { variant1 } from './service/contstants';

const FreeFormText = ({ fields, params, rendering }) => {
  const appName = useAppName();

  let variant;
  switch (appName) {
    case HONDA_SITE_NAME:
      variant = variant1;
      break;
    default:
      break;
  }

  return <FreeFormTextUI fields={fields} params={params} rendering={rendering} variant={variant} />;
};

export default FreeFormText;
